import React, { useEffect, useRef } from 'react'
import URL from './URL'
import RenderValidateMessage from '../../../stories/Validation/RenderValidateMessage'
import * as QRCode from 'easyqrcodejs';

import { UtilityStepHeader } from '@axshealth/design-library'
import { Form, Card, Row, Col, Button, Alert } from 'react-bootstrap'

const CURRENT_STEP = 'PERSONALIZED_DOMAIN';

const stepColor = {
  icon: {
    current: '#17A2B8',
    complete: '#4CDC6C',
    incomplete: '#D8D8D8',
  },
  text: {
    current: '',
    complete: '',
    incomplete: '#6F6F6F',
  }
};

export default function Domain({
  step,
  steps,
  errors,
  domain,
  stepBack,
  stepForward,
  profileImage,
  validateDomain,
}) {
  const qrcodeDOM = useRef(null);

  const generateQR = () => {
    const options = {
      text: `https://${domain}.${process.env.REACT_APP_DOMAIN}`,
      logo: profileImage,
      drawer: 'svg',
      width: 100,
      height: 100,
      logoWidth: 35,
      logoHeight: 35,
      colorDark: "#000000",
      colorLight: "#ffffff",
      logoBackgroundTransparent: true,
      correctLevel: QRCode.CorrectLevel.H, // L, M, Q, H
    }

    new QRCode(qrcodeDOM.current, options)
  }

  useEffect(() => {
    if (qrcodeDOM.current) {
      generateQR();
    }
  });

  if (step !== CURRENT_STEP) {
    return null
  }

  return <Row>
    <Col className='px-0'>
      <Card style={{ height: '40em' }}>
        <Card.Body>
          <UtilityStepHeader steps={steps} stepColor={stepColor} />

          <Row>
            <Col xs='12' className="mt-3 mb-4">
              <Alert variant='primary'>
                Your patients will be able to access your landing page using your personalized domain. Start by entering your unique domain.
              </Alert>
            </Col>
            <Col xs='5'>
              <Form>
                <Form.Group className="mb-5" controlId="formEnterDomain">
                  <Form.Label>Enter your domain</Form.Label>
                  <Form.Control type="text" value={domain} placeholder="Enter domain" onChange={e => validateDomain(e.target.value)} isInvalid={errors} isValid={!errors} />
                  <RenderValidateMessage errors={errors} field="domain" />
                  <Form.Text className="text-danger font-weight-bold">
                    Domains cannot be changed once your landing page is published.
                  </Form.Text>
                </Form.Group>

                <Form.Group>
                  <Button block disabled={errors} variant={errors ? 'secondary' : 'success'} onClick={stepForward}>Next</Button>
                  <div className="text-center mt-2">
                    <Button variant='link' onClick={stepBack}>Cancel</Button>
                  </div>
                </Form.Group>
              </Form>
            </Col>
            <Col xs={{ span: '6', offset: 1 }}>
              <Row>
                <Col xs='12'>
                  <div className='mb-2 font-weight-bold'>Domain</div>
                  <URL urlString={`https://${domain}.${process.env.REACT_APP_DOMAIN}`} />
                </Col>
                <Col xs='12' className="mt-5">
                  <div className='font-weight-bold mb-2'>QR Code</div>
                  <div ref={qrcodeDOM} className='img-fluid'></div>
                </Col>
              </Row>
            </Col>

          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row>
}